import { observable, action } from 'mobx';
import { IProductRepositoryConfig } from '~repositories/ProductRepository';
import { IFeatures } from '../../constants/Features';
import { IEarlyAccessInfo }  from '~api/EarlyAccessAPI';

export interface IProductServiceConfig extends IProductRepositoryConfig {
    currency: string;
    features: IFeatures;
    graphqlExtensionVersion: string;
    prodcatInventory?: {
        legacy?: boolean;
    };
    domainLangPrefix?: string;
    drupal?: {
        languagePathPrefix?: string;
    };
    env?: string;
    enableLoyaltyEarlyAccessDynamicCTA?: boolean;
    earlyAccessInfo?: IEarlyAccessInfo;
    earlyAccessLoaded?: boolean;
}

export class Config {
    @observable public config: IProductServiceConfig;

    constructor(config?: IProductServiceConfig) {
        if (config) {
            this.config = config;
        }
    }

    @action
    public updateConfig(config: Partial<IProductServiceConfig>) {
        this.config = { ...this.config, ...config };
    }
}
